import {get} from 'lodash'
import {
  getCompanyLayoutFilters,
  getLayoutFilterValues,
  getLayoutGroupsValues,
  getNonEmptyLayoutFilters,
  getStatusLayoutFilters,
} from 'helpers/layouts'

export const getInvoiceLayoutParams = (params) => {
  const layoutId = get(params, 'layoutId', null)
  const groups = get(params, 'groups', [])
  const companies = get(params, 'companies', [])

  const layoutFilters = [
    {
      layoutId,
      key: 'statusTypes',
      value: getStatusLayoutFilters(params, 'statusTypes'),
    },
    {
      layoutId,
      key: 'companies',
      value: getCompanyLayoutFilters(companies),
    },
    {
      layoutId,
      key: 'userTypes',
      value: getLayoutFilterValues(params, 'userTypes'),
    },
    {
      layoutId,
      key: 'contacts',
      value: getLayoutFilterValues(params, 'contacts'),
    },
    {
      layoutId,
      key: 'timeKey',
      value: get(params, 'timeKey', null),
    },
    {
      layoutId,
      key: 'targetStart',
      value: get(params, 'targetStart', null),
    },
    {
      layoutId,
      key: 'targetEnd',
      value: get(params, 'targetEnd', null),
    },
    {
      layoutId,
      key: 'orderTypeId',
      value: getLayoutFilterValues(params, 'orderTypeId'),
    },
    {
      layoutId,
      key: 'search',
      value: get(params, 'search', null),
    },
    {
      layoutId,
      key: 'sortColumn',
      value: get(params, 'sortColumn', null),
    },
    {
      layoutId,
      key: 'sortDirection',
      value: get(params, 'sortDirection', null),
    },
    {
      layoutId,
      key: 'selectedFields',
      value: getLayoutFilterValues(params, 'selectedFields', ';'),
    },
  ]
  const filters = getNonEmptyLayoutFilters(layoutFilters)

  filters.push({
    layoutId,
    key: 'showDormants',
    value: get(params, 'showDormants', false),
  })

  return {
    layoutFilters: filters,
    layoutGroups: getLayoutGroupsValues(layoutId, groups),
  }
}
